angular.module('website').controller('website.requestAccessCtrl', ["$scope", "$http", "$timeout", "$q", "DataService", function($scope, $http, $timeout, $q, DataService) {
  var setLinksTarget, validate;
  $scope.pixelId = DataService.gym_config.facebook_pixel_id_for_contact_us_page;
  $scope.pixelEvent = DataService.gym_config.facebook_pixel_event_for_contact_us_page;
  $scope.gtmId = DataService.gym_config.gtm_code_for_contact_us_page;
  $scope.contact = {};
  $http.get(`/gyms/${DataService.gym_id}/privacy_policies?filters[policy_context]=gym_website`).then(function(response) {
    $scope.privacyPolicies = response.data.collection;
    $scope.contact.privacy_policy_responses_attributes = $scope.privacyPolicies.map(function(item) {
      return {
        privacy_policy_id: item.id,
        accepted: false
      };
    });
    return setLinksTarget();
  });
  setLinksTarget = function() {
    return $timeout(function() {
      return angular.element('.form-group a').each(function(i, element) {
        return element.target = '_blank';
      });
    });
  };
  $scope.isFormInvalid = function() {
    return false;
  };
  validate = function() {
    var deferred, ref, ref1, ref2;
    deferred = $q.defer();
    $scope.contact.errors = {};
    if (!((ref = $scope.contact.contact_first_name) != null ? ref.trim() : void 0)) {
      $scope.contact.errors.contact_first_name = ['This field is required'];
    }
    if (!((ref1 = $scope.contact.contact_last_name) != null ? ref1.trim() : void 0)) {
      $scope.contact.errors.contact_last_name = ['This field is required'];
    }
    if (!((ref2 = $scope.contact.email) != null ? ref2.trim() : void 0)) {
      $scope.contact.errors.email = ['This field is required'];
    }
    if (_.isEmpty($scope.contact.errors)) {
      deferred.resolve();
    } else {
      deferred.reject();
    }
    return deferred.promise;
  };
  $scope.isSaved = false;
  return $scope.save = function() {
    return validate().then(function() {
      $scope.isLoading = true;
      $scope.errorMessage = "";
      return $http.post(`/websites/${DataService.domain}/access_requests`, {
        mobile_app_access_request: $scope.contact
      }).then(function(response) {
        $scope.isSaved = true;
        return $scope.isLoading = false;
      }, function(response) {
        $scope.contact.errors = response.data.errors;
        $scope.errorMessage = "Please ensure that your email is correct and that you've filled out the required fields";
        return $scope.isLoading = false;
      });
    });
  };
}]);
